export default "__VITE_PUBLIC_ASSET__d2c97c86__"